import { localStorageKeys } from 'Config';

const getActiveLanguageForMasterPass = () => {
  const language = localStorage.getItem(localStorageKeys.i18nextLng);
  const languageId = language === 'en' ? '1' : '2';
  return languageId === '1' ? 'eng' : 'tur';
};

export default getActiveLanguageForMasterPass;
